import CmSceneNote from '../cm-scene-notes/cm-scene-note.entity';
import HaSceneNote from '../ha-scene-notes/ha-scene-note.entity';
import MuSceneNote from '../mu-scene-notes/mu-scene-note.entity';
import PrSceneNote from '../pr-scene-notes/pr-scene-note.entity';
import { SosUpdateResponse } from '../sos-response';

export interface SceneNoteMultiDeptUpdateResponse extends SosUpdateResponse {
	created: {
		CmSceneNote?: CmSceneNote[];
		HaSceneNote?: HaSceneNote[];
		MuSceneNote?: MuSceneNote[];
		PrSceneNote?: PrSceneNote[];
	};
	updated: {
		CmSceneNote?: CmSceneNote[];
		HaSceneNote?: HaSceneNote[];
		MuSceneNote?: MuSceneNote[];
		PrSceneNote?: PrSceneNote[];
	};
}
